import { observer } from 'mobx-react';
import * as React from 'react';
import { CurrentUserResource } from '../CurrentUser/Types';
import { error } from '../ErrorHandling';
import { errorAlert } from '../Notifications/Types';
import { FlashMessage } from '../components/FlashMessage';
import BrandLoader from '../components/BrandLoader';
import PreferredLanguageSelector from './PreferredLanguageSelector';
import { preferredLanguageSelectionStore } from './Store';

interface Props {
  children: React.ReactNode;
  currentUserResource: CurrentUserResource;
}

class PreferredLanguageSelection extends React.Component<Props> {
  componentDidMount(): void {
    preferredLanguageSelectionStore.detectingPreferredLanguage(this.props.currentUserResource);
  }

  render() {
    const { children } = this.props;
    switch (preferredLanguageSelectionStore.state.kind) {
      case 'waiting':
      case 'detecting-preferred-language':
      case 'updating-preference':
      case 'changing-browser-language':
        return <BrandLoader />;
      case 'requires-user-selection':
        return <PreferredLanguageSelector />;
      case 'preference-identified':
        return <>{children}</>;
      case 'errored':
        return (
          <FlashMessage
            alert={errorAlert(error(preferredLanguageSelectionStore.state.userMessage))}
          />
        );
    }
  }
}

export default observer(PreferredLanguageSelection);
